import { VehicleTypeEnum } from '@/services/api-clients';

export function vehicleTypeIconFilter(vehicleType: VehicleTypeEnum) {
  switch (vehicleType) {
    case VehicleTypeEnum.Bike: return 'mdi-bike';
    case VehicleTypeEnum.ElectricBike: return 'mdi-bicycle-electric';
    case VehicleTypeEnum.Motor: return 'mdi-motorbike';
    case VehicleTypeEnum.Car: return 'mdi-car-hatchback';
    default: return '';
  }
}
